type RuntimeEnv = {
  VITE_API_URL?: string;
};

type WindowWithEnv = Window & { __ENV?: RuntimeEnv };

const runtimeEnv: RuntimeEnv =
  typeof window !== "undefined" ? ((window as WindowWithEnv).__ENV ?? {}) : {};

export const appEnv: RuntimeEnv = {
  VITE_API_URL: runtimeEnv.VITE_API_URL ?? import.meta.env.VITE_API_URL,
};

export function getBuildLabel(): string {
  const v = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "—";
  const t = typeof __BUILD_TIMESTAMP__ !== "undefined" ? new Date(__BUILD_TIMESTAMP__).toLocaleString() : "—";
  return `v${v} · ${t}`;
}
